var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 322 68",
    style: {
      enableBackground: "new 0 0 322 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FF006E;}\n\t.st2{fill:#FF93B8;}\n\t.st3{fill:#E85D88;}\n\t.st4{fill:#EF9A9D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.7,48.1l6.4,6.3c0.1,0.1,0.3,0.3,0.5,0.4c0.1-0.2,0.3-0.4,0.4-0.7c0.6-1.2,1-2.6,1-4.1V18 c0-5.3-4.3-9.6-9.7-9.6h-3c-1,0-1.9,0.2-2.8,0.5c-2.6,0.8-4.7,2.6-5.9,5c-0.6,1.2-1,2.6-1,4.1v19.6c2.5,0.6,5.5,1.9,7.9,4.2 L28.7,48.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.9,47.9c-0.4-0.4-0.9-0.7-1.5-1v3.2c0,5.3,4.3,9.6,9.7,9.6h3c0.2,0,0.5,0,0.7,0l-5.3-5.2L15.9,47.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,12.2c-0.4,0.9-0.7,1.8-1,2.8C10.7,14,11,13.1,11.4,12.2L11.4,12.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.2,9c0.9-0.3,1.8-0.5,2.8-0.5h3c5.3,0,9.7,4.3,9.7,9.6v32c0,1.5-0.4,2.9-1,4.1c-0.1,0.2-0.2,0.4-0.4,0.7 c1.1,0.9,2.5,1.5,3.8,1.9c0.2-0.3,0.3-0.5,0.4-0.8c0.9-1.8,1.4-3.9,1.4-6V18.3C41.1,10.5,35,4,27.1,4h-2.8c-3.1,0-5.9,1-8.2,2.6 c-2,1.4-3.6,3.3-4.7,5.6l3.9,1.7C16.5,11.6,18.6,9.7,21.2,9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.4,12.2L11.4,12.2c1.1-2.2,2.7-4.1,4.7-5.6C18.4,5,21.3,4,24.3,4h2.8c7.8,0,14,6.5,14,14.2v31.6 c0,2.2-0.5,4.2-1.4,6c-0.1,0.3-0.3,0.6-0.4,0.8c1.3,0.4,2.5,0.6,3.2,0.6h1.5c1-2.2,1.6-4.6,1.6-7.2V18c0-9.9-8.2-18-18.3-18h-3 C19.3,0,15,1.8,11.8,4.7C10,6.3,8.6,8.2,7.6,10.4L11.4,12.2C11.4,12.2,11.4,12.2,11.4,12.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "5.8,36.9 2.7,36.9 0,40.9 5.8,40.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.4,57.3h-4.5h-1.5c-0.6,0-1.8-0.2-3.2-0.6c-1.3-0.4-2.7-1-3.8-1.9c-0.2-0.1-0.3-0.3-0.5-0.4l-6.4-6.3 l-6.4-6.3c-2.4-2.4-5.3-3.6-7.9-4.2v4.7c2,0.8,4.2,1.9,6,3.7l6.4,6.3l5.7,5.6l0.7,0.7c0.8,0.8,1.9,1.4,3,1.8 c1.8,0.7,3.6,0.9,4.4,0.9h0.8h9.7L48.4,57.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.8,65.3c1.2,0.3,2.2,0.4,3.1,0.5C39.1,65.7,38,65.5,36.8,65.3C36.9,65.2,36.8,65.3,36.8,65.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 40.9,
    className: "st1",
    width: 5.8,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.4,12.2C11.4,12.2,11.4,12.2,11.4,12.2l-3.9-1.8c0,0,0,0,0,0.1L11.4,12.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.8,63.1C31.8,63.1,31.8,63.1,31.8,63.1c1.7,1.1,3.5,1.8,5.1,2.2c0,0,0,0,0,0 C35.3,64.9,33.5,64.2,31.8,63.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.8,63.1c-1.3,0.5-2.8,0.8-4.4,0.8l-3.1,0c-8-0.4-14.2-6.5-14.2-14.2v-4.1v-4.3v-4.3V18.1 c0-1,0.1-2.1,0.4-3c0.2-1,0.5-1.9,1-2.8l-3.9-1.7c0,0,0,0,0-0.1l0,0c-1.1,2.3-1.7,4.9-1.7,7.6v18.9v4v4.5V50c0,9.9,8.2,18,18.3,18 h3c3.6,0,6.9-1,9.7-2.8C35.2,64.9,33.5,64.2,31.8,63.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.6,63C31.6,63,31.6,63,31.6,63c-0.4-0.3-0.8-0.6-1.2-0.9C30.8,62.4,31.2,62.7,31.6,63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.6,63c-0.4-0.3-0.8-0.6-1.2-0.9c-0.6-0.5-1.1-1-1.6-1.5l-0.9-0.9c-0.2,0-0.5,0-0.7,0h-3 c-5.3,0-9.7-4.3-9.7-9.6v-3.2v-4.6v-4.7V18c0-1.5,0.4-2.8,1-4.1l-3.9-1.7c-0.4,0.9-0.7,1.8-1,2.8c-0.2,1-0.3,1.9-0.3,3v19v4.3v4.3 c0,0,0,0,0,0v4.1c0,7.7,6.2,13.8,14.2,14.2l3.1,0c1.6,0,3.1-0.3,4.4-0.8C31.7,63,31.7,63,31.6,63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.1,18c0-1,0.1-2,0.3-3C10.2,16,10.1,17,10.1,18l0,19c0,0,0,0,0,0V18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.1,36.9C10.1,36.9,10.1,36.9,10.1,36.9l0,4.3c0,0,0,0,0,0V36.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.1,41.2C10.1,41.2,10.1,41.2,10.1,41.2l0,4.3c0,0,0,0,0,0V41.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.6,63c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0C31.7,63,31.7,63,31.6,63C31.6,63,31.6,63,31.6,63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.5,54.4l5.3,5.2c0,0,0,0,0,0L22.5,54.4L22.5,54.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.9,65.7c1.3,0.1,2.2,0,2.4,0C42.1,65.8,41.2,65.8,39.9,65.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.7,60.5c0.5,0.6,1.1,1.1,1.6,1.5c-0.5-0.4-1-0.9-1.5-1.4l-1.1-1c0,0,0,0,0,0L28.7,60.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.4,61.3h-0.8c-0.8,0-2.6-0.2-4.4-0.9c-1.1-0.4-2.2-1-3-1.8L32.5,58l-5.7-5.6l-6.4-6.3c-1.8-1.8-4-3-6-3.7 v4.6c0.6,0.3,1.1,0.6,1.5,1l6.6,6.5l0,0l5.3,5.2l1.1,1c0.5,0.5,1,1,1.5,1.4c0.4,0.3,0.8,0.7,1.3,0.9c0,0,0.1,0.1,0.1,0.1 c1.7,1.1,3.5,1.8,5.1,2.2c1.2,0.3,2.2,0.4,3.1,0.5c1.3,0.1,2.2,0,2.4,0h8.7v-4.5H41.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,24.4c0-5.4,3.1-8.5,8.9-8.5c5.7,0,8.9,3.1,8.9,8.5V42c0,1.9-0.4,3.5-1.1,4.7c0.3,0.6,0.7,0.7,1.6,0.7 h0.5v4.7h-0.8c-2.6,0-4.3-0.9-5.1-2.3c-1.2,0.4-2.6,0.6-4.1,0.6c-5.7,0-8.9-3.1-8.9-8.5V24.4z M73.1,42.3c0,2.4,1.2,3.3,3,3.3 c1.9,0,3-0.9,3-3.3V24c0-2.4-1.2-3.3-3-3.3c-1.9,0-3,0.9-3,3.3V42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97,16.3v26.1c0,2.4,1.2,3.3,3,3.3c1.9,0,3-0.9,3-3.3V16.3h5.5V42c0,5.4-3,8.5-8.7,8.5c-5.7,0-8.7-3.1-8.7-8.5 V16.3H97z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "121.1,30.5 129.2,30.5 129.2,35.3 121.1,35.3 121.1,45.2 131.2,45.2 131.2,50.1 115.3,50.1 115.3,16.3 131.2,16.3 131.2,21.1 121.1,21.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "143.4,30.5 151.4,30.5 151.4,35.3 143.4,35.3 143.4,45.2 153.5,45.2 153.5,50.1 137.5,50.1 137.5,16.3 153.5,16.3 153.5,21.1 143.4,21.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "165.1,25.6 165,25.6 165,50.1 159.7,50.1 159.7,16.3 167,16.3 172.9,36.5 173,36.5 173,16.3 178.3,16.3 178.3,50.1 172.2,50.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193,15.9c5.7,0,8.6,3.1,8.6,8.5v1.1h-5.5V24c0-2.4-1.1-3.3-2.9-3.3c-1.9,0-2.9,0.9-2.9,3.3 c0,2.5,1.2,4.3,5,7.3c4.9,3.9,6.4,6.7,6.4,10.6c0,5.4-3,8.5-8.7,8.5c-5.7,0-8.7-3.1-8.7-8.5v-2.1h5.5v2.4c0,2.4,1.2,3.3,3,3.3 c1.9,0,3-0.9,3-3.3c0-2.5-1.2-4.3-5-7.3c-4.9-3.9-6.4-6.7-6.4-10.6C184.4,19,187.3,15.9,193,15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.4,15.9c5.7,0,8.6,3.1,8.6,8.5v1.1h-5.5V24c0-2.4-1.1-3.3-2.9-3.3c-1.9,0-2.9,0.9-2.9,3.3 c0,2.5,1.2,4.3,5,7.3c4.9,3.9,6.4,6.7,6.4,10.6c0,5.4-3,8.5-8.7,8.5c-5.7,0-8.7-3.1-8.7-8.5v-2.1h5.5v2.4c0,2.4,1.2,3.3,3,3.3 c1.9,0,3-0.9,3-3.3c0-2.5-1.2-4.3-5-7.3c-4.9-3.9-6.4-6.7-6.4-10.6C217.8,19,220.7,15.9,226.4,15.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "253.5,40.3 253.6,40.3 257.5,16.3 265.6,16.3 265.6,50.1 260.1,50.1 260.1,25.8 260,25.8 256.1,50.1 250.5,50.1 246.3,26.2 246.2,26.2 246.2,50.1 241.1,50.1 241.1,16.3 249.2,16.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.6,
    y: 16.3,
    className: "st2",
    width: 5.8,
    height: 33.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "285.3,16.3 291.2,16.3 291.2,45.2 300.8,45.2 300.8,50.1 285.3,50.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "311.9,30.5 319.9,30.5 319.9,35.3 311.9,35.3 311.9,45.2 322,45.2 322,50.1 306,50.1 306,16.3 322,16.3 322,21.1 311.9,21.1  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.088a217d480e37b2fd0039e442e71379.svg";
export { ForwardRef as ReactComponent };